import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';

const styles = css`
  .AreaInfo {
    width: 100%;
    padding: 100px 0 0 0;
    display: flex;
    .AreaInfo_media {
      margin: 0 0 15px 0;
      @media(max-width: 767px) {
        order: 1;
      }
      img {
        width: 100%;
        height: auto;
      }
    }
    .AreaInfo_content {
      .AreaInfo_title {
        font-weight: 200;
        font-size: 70px;
        color: #074585;
        line-height: 80px;
        margin: 0 0 60px 0;
        position: relative;
        &:after {
          content: '';
          display: block;
          width: 200px;
          height: 3px;
          position: absolute;
          bottom: -10px;
          left: 0;
          background-color: #B3CED0;
        }
        @media (min-width: 992px) {
          font-size: 120px;
          line-height: 114px;
        }
      }
      .AreaInfo_postTitle {
        font-weight: 900;
        font-size: 24px;
        color: #333333;
        display: block;
        @media (min-width: 992px) {
          font-size: 32px;
        }
      }
      .AreaInfo_body {
        font-weight: 300;
        font-size: 19px;
        line-height: 35px;
        color: #333333;
      }
    }
  }
`;

function BuilderAreas({ area, page }) {
  return (
    <div className={styles}>
      <div className="AreaInfo">
        <div className="AreaInfo_wrapper container">
          <div className="AreaInfo_inner row">
            <div className="AreaInfo_media col-lg-6">
              {/* <img src="/images/area-info-image.jpg" alt="" /> */}
              <img src={get(area, 'logo.contentUrl', get(page, 'page_image.contentUrl'))} alt="" />
              <img src={get(page, 'bottom_image.contentUrl')} alt="" />
            </div>
            <div className="AreaInfo_content col-lg-5 ml-auto">
              <h3 className="AreaInfo_title">
                Living in<span className="AreaInfo_postTitle">{get(area, 'name') || get(page, 'lead_copy')}, {get(area, 'state') || get(page, 'state')}</span>
              </h3>
              <p className="AreaInfo_body" dangerouslySetInnerHTML={SanitizeHtml(get(area, 'description', get(page, 'body_copy')))} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

BuilderAreas.propTypes = {
  area: PropTypes.object,
  page: PropTypes.object.isRequired,
};

BuilderAreas.defaultProps = {
  area: undefined,
};

export default withData(
  {
    area: true,
    page: 'default_area',
  },
  {
    required: {
      communities: true,
      page: true,
    },
  },
)(BuilderAreas);



// WEBPACK FOOTER //
// ./src/components/BuilderAreas/index.js